import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const TShirt = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={props.color || theme.palette.grey600}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.1667 4.02637V4.02637C21.1667 5.08021 20.7481 6.09088 20.0029 6.83606C19.2577 7.58124 18.247 7.99987 17.1932 7.99987H15.8069C14.753 7.99987 13.7424 7.58124 12.9972 6.83606C12.252 6.09088 11.8334 5.08021 11.8334 4.02637V4.02637" />
      <path d="M24.4835 18.6613L28.8054 17.6433C29.1527 17.5615 29.4527 17.3439 29.6383 17.0392C29.8239 16.7346 29.8797 16.3682 29.7932 16.0221L28.0656 9.11155C27.6786 7.56368 26.619 6.27036 25.1775 5.58649L22.9184 4.51475C22.204 4.17583 21.4231 4 20.6324 4H12.3676C11.5769 4 10.796 4.17583 10.0816 4.51475L7.82255 5.58649C6.38104 6.27036 5.3214 7.56368 4.93443 9.11155L3.20681 16.022C3.12028 16.3682 3.17607 16.7345 3.36171 17.0392C3.54736 17.3439 3.84736 17.5614 4.19463 17.6432L8.4833 18.6535" />
      <path d="M6.05139 6.93092L8.00874 11.7428C8.33325 12.5405 8.50012 13.3936 8.50011 14.2548L8.49995 26.0578C8.48675 27.2553 9.2834 28.3108 10.4386 28.6264C14.4246 29.5692 18.5756 29.5691 22.5616 28.6261C23.7167 28.3104 24.5132 27.2549 24.5 26.0575L24.4998 14.2545C24.4998 13.3933 24.6667 12.5402 24.9912 11.7425L26.9485 6.93066" />
    </svg>
  );
};
